import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementReceivedMethodComponent } from './case-management-received-method.component';

const routes: Routes = [{ path: '', component: CaseManagementReceivedMethodComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementReceivedMethodRoutingModule { }
